import { forwardRef, useCallback, useEffect, useState } from "react";

export const HoverableImagePreview = forwardRef((props: Props, ref?: any) => {
  const { hoverSource, staticSource, alt, className } = props;
  const [imgSource, setImgSrc] = useState(staticSource);

  const onMouseOver = useCallback(() => setImgSrc(hoverSource), [hoverSource]);
  const onMouseOut = useCallback(() => setImgSrc(staticSource), [staticSource]);

  useEffect(() => {
    if (ref) {
      ref.current.onmouseover = () => onMouseOver();
      ref.current.onmouseout = () => onMouseOut();
    }
  }, [onMouseOut, onMouseOver, ref]);

  return (
    <img
      onMouseOut={onMouseOut}
      onMouseOver={onMouseOver}
      src={imgSource}
      alt={alt}
      className={className}
      loading="lazy"
    />
  );
});

HoverableImagePreview.displayName = "HoverableImagePreview";

interface Props {
  hoverSource: string;
  staticSource: string;
  alt?: string;
  className?: string;
}
